import home from './home';
import common from './common';
import navigation from './navigation';
import blockchain from './blockchain';
import firmwareUpgrade from './firmwareUpgrade';
import security from './security';
import keypal from './keypal';
import academy from './academy';
import safebox from './safebox';
import keypalCard from './keypalCard';
import keypalTutorial from './keypalTutorial';
import keypalTwo from './keypalTwo';

export default {
  home,
  common,
  navigation,
  blockchain,
  firmwareUpgrade,
  security,
  keypal,
  academy,
  safebox,
  keypalCard,
  keypalTutorial,
  keypalTwo,
};
